import { LabeledCheckBox } from './LabeledCheckBox';

import { CheckboxesAction, CheckboxesState } from './useCheckboxes';
import classes from './CreateInvite.Content.module.scss';

export type CheckboxesProps = {
  title: string;

  state: CheckboxesState;
  onCheckedChange?: (action: CheckboxesAction) => void;

  disabled: boolean;
};

export const Checkboxes = ({
  title,
  //
  state,
  //
  disabled,
  ...props
}: CheckboxesProps) => {
  const onCheckedChange = (key: keyof CheckboxesState) => (checked: boolean) =>
    props.onCheckedChange?.({ key, checked });

  return (
    <div className={classes.checkboxesWrapper}>
      <h3 className={classes.checkboxesTitle}>{title}</h3>
      <div className={classes.checkboxes}>
        <LabeledCheckBox
          disabled={disabled}
          checked={state.admin}
          onCheckedChange={onCheckedChange('admin')}
        >
          Администратор
        </LabeledCheckBox>
        <LabeledCheckBox
          disabled={disabled}
          checked={state.send_pulse}
          onCheckedChange={onCheckedChange('send_pulse')}
        >
          Отправлять Пульс телеграм
        </LabeledCheckBox>
        <LabeledCheckBox
          disabled={disabled}
          checked={state.audience}
          onCheckedChange={onCheckedChange('audience')}
        >
          Отображать раздел «Аудитория»{' '}
        </LabeledCheckBox>
        <LabeledCheckBox
          disabled={disabled}
          checked={state.invite_link}
          onCheckedChange={onCheckedChange('invite_link')}
        >
          Отображать все ссылки и аналитику по ним
        </LabeledCheckBox>
      </div>
    </div>
  );
};
